module.exports = __webpack_public_path__ + "static/media/ai.9fe4d6b7.svg";